import { Component, OnInit } from '@angular/core';
import { CreateCompetition } from '../../../models/inModels/Competition';
import { Message } from 'primeng/primeng';
import { CompetitionService } from '../../../services/competition/competition.service';
import { Router } from '@angular/router';
import { StorageService } from '../../../services/system/storage.service';

@Component({
  selector: 'app-create-competition',
  templateUrl: './create-competition.component.html',
  styleUrls: ['./create-competition.component.css']
})
export class CreateCompetitionComponent implements OnInit {
  isOpen = false;

  selectedOption: any = null;
    model: CreateCompetition;
    loading = false;
    error: Message[];
    competitions;
    fieldTypes = [
      { id: 1, name: 'Text' },
      { id: 2, name: 'Number' },
      { id: 3, name: 'Date' },
      { id: 4, name: 'Boolean' },
      { id: 5, name: 'Upload' },
      { id: 6, name: 'Dropdown (Single)' },
      { id: 7, name: 'Dropdown (Multi)' }
    ];
    minDate: Date = new Date();


  constructor(
    private router: Router,
        private service: CompetitionService,
        public storageService: StorageService,
  ) { 
    this.model = new CreateCompetition();
  }

  ngOnInit() {
    this.minDate = new Date();
  }

  goBack(): void {
		this.router.navigate(['/competitions']);
  }

  save(): void {
    console.log(this.model);
		this.loading = true;
		this.service.create(this.model).then(
			result => {
				console.log(result);
				this.loading = false;
				this.goBack();
			},
			error => {
				this.loading = false;
				this.error = [];
				this.error.push({ severity: 'error', summary: 'Error', detail: error });
			});
  }

  onEnabledChange(value: boolean) {
    this.model.Enabled = value; 
  }

  addCustomField() {
    if (!this.model.CustomFields) {
      this.model.CustomFields = [];
    }
  
    this.model.CustomFields.push({
      FieldName: '',
      FieldType: 1, // Default to 'Text' (as per your enum)
      IsRequired: false,
      CompetitionCustomFieldOptions: []
    });
  }

  removeCustomField(index: number) {
    this.model.CustomFields.splice(index, 1);
  }

  addDropdownOption(field: any) {
    if (!field.CompetitionCustomFieldOptions) {
      field.CompetitionCustomFieldOptions = [];
    }
    field.CompetitionCustomFieldOptions.push({ OptionText: '' });
  }
  
  
  removeDropdownOption(field: any, index: number) {
    if (field.CompetitionCustomFieldOptions && field.CompetitionCustomFieldOptions.length > index) {
      field.CompetitionCustomFieldOptions.splice(index, 1);
    }
  }
  
  onFieldTypeChange(field: any) {
    if (field.FieldType !== 'Dropdown') {
      field.CompetitionCustomFieldOptions = []; 
    }
  }

  handleImage(event): void {
		var result = this.storageService.handleSuccess(event);
		
		this.model.ImageId = result.PublicId;
		this.loading = false;
	}

	handleError(event): void {
		this.loading = false;
		this.error = [];
		this.storageService.handleError(event, this.error);
	}

	removeImage(): void {
		this.model.ImageId = null;
		this.loading = false;
	}

  trackByIndex(index: number, item: any): number {
    return index;
  }
}



// WEBPACK FOOTER //
// ./src/app/components/competitions/create-competition/create-competition.component.ts